export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/TD-270aa958327f90375345f70a2072a50e.png";